import globals from '../globals';
import helpers from '../helpers';

const $search = $('.mosaic-search');
const $close = $search.find('.mosaic-search__close');
const $input = $search.find('.mosaic-search__input');
const $find = $search.find('.mosaic-search__find');
const $empty = $search.find('.mosaic-search__empty');
const $error = $search.find('.mosaic-search__error');
const $list = $search.find('.mosaic-search__list');
const $loadMore = $search.find('.mosaic-search__load-more');

const requestUrl = './data/search.json';
const loadAllValue = 'all';
const loadItemsCount = 20;

function isActive() {
	return $search.hasClass('is-active');
}

function createItems(data, append = false) {
	if (typeof data === 'undefined' || !data.length) {
		return;
	}

	let template = '';

	data.forEach((item) => {
		template += `
			<div class="mosaic-search__item">
				<div class="mosaic-search__photo">
					<img src="${item.photo}" alt="${item.name}">
				</div>
				<div class="mosaic-search__block">
					<div class="mosaic-search__name">${item.name}</div>
					<button type="button" class="mosaic-search__show js-mosaic-show" data-id="${item.id}">Показать</button>
				</div>
			</div>
		`;
	});

	$list[append ? 'append' : 'html'](template);
}

function showState(state) {
	$empty.toggleClass('is-active', state === 'empty');
	$error.toggleClass('is-active', state === 'error');
	$list.toggleClass('is-active', state === 'list');
}

function toggleLoadMore(state, requestData) {
	$loadMore
		.toggleClass('is-active', state)
		.data('request', requestData);
}

function request(defaultData = $input.serialize(), more = false) {
	$search.addClass('is-loading');

	$.ajax({
		url: requestUrl,
		data: defaultData,
		timeout: 30000,
		success(data) {
			if (!data.length) {
				showState('empty');

				return;
			}

			const itemsCount = more ? $list.find('.mosaic-search__item').length : 0;
			const loadMoreToggleState = data.length - itemsCount > loadItemsCount;

			data = data.splice(itemsCount, loadItemsCount);

			createItems(data, more);
			showState('list');
			toggleLoadMore(loadMoreToggleState, defaultData);
		},
		error() {
			showState('error');
		},
		complete() {
			$search.removeClass('is-loading');
		},
	});
}

function find() {
	const requestData = $input.val().length ? undefined : loadAllValue;

	request(requestData);
}

function loadMore() {
	const requestData = $loadMore.data('request');

	if (typeof requestData !== 'undefined') {
		request(requestData, true);
	}
}

function open() {
	$search.addClass('is-active');
	$input
		.focus()
		.val('');

	helpers.lockScroll(true, $search);
	helpers.scrollTo(0, undefined, $search);

	showState('list');
	request(loadAllValue);
}

function close() {
	$search.removeClass('is-active');

	helpers.lockScroll(false, $search);
}

function init() {
	globals.$document
		.on('click.mosaic-search', '.js-mosaic-search-open', open)
		.on('keydown.mosaic-search', (e) => {
			if (isActive() && e.keyCode === 27) {
				close();
			}
		})
		.on('click.mosaic-search', '.mosaic-search__show', close);

	$close.on('click.mosaic-search', close);
	$find.on('click.mosaic-search', find);
	$loadMore.on('click.mosaic-search', loadMore);
}

init();
